"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";

/**
 * Component that stores the backend JWT token in localStorage
 * when the NextAuth session is available.
 * This allows api-client to access the token for API requests.
 */
export function TokenStorage() {
  const { data: session, status } = useSession();

  useEffect(() => {
    // Only act when session status is determined (not "loading")
    if (status === "loading") {
      // Preserve existing token during session loading
      return;
    }

    if (status === "authenticated" && session && (session as any).backendToken) {
      // Store backend token in localStorage for api-client
      localStorage.setItem("token", (session as any).backendToken);
    } else if (status === "unauthenticated") {
      // Only clear token when we're sure there's no session
      localStorage.removeItem("token");
    }
  }, [session, status]);

  return null; // This component doesn't render anything
}

